import {} from '@blocksuite/global/utils';
import {} from '@blocksuite/store';
import {} from '../surface-block/consts.js';
import {} from '../surface-block/elements/index.js';
export var LineWidth;
(function (LineWidth) {
    LineWidth[LineWidth["LINE_WIDTH_TWO"] = 2] = "LINE_WIDTH_TWO";
    LineWidth[LineWidth["LINE_WIDTH_FOUR"] = 4] = "LINE_WIDTH_FOUR";
    LineWidth[LineWidth["LINE_WIDTH_SIX"] = 6] = "LINE_WIDTH_SIX";
    LineWidth[LineWidth["LINE_WIDTH_EIGHT"] = 8] = "LINE_WIDTH_EIGHT";
    LineWidth[LineWidth["LINE_WIDTH_TEN"] = 10] = "LINE_WIDTH_TEN";
    LineWidth[LineWidth["LINE_WIDTH_TWELVE"] = 12] = "LINE_WIDTH_TWELVE";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    LineWidth[LineWidth["Thin"] = 4] = "Thin";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    LineWidth[LineWidth["Thick"] = 10] = "Thick";
})(LineWidth || (LineWidth = {}));
//# sourceMappingURL=types.js.map